// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"424d5d00","977":"8a2ad549"}[chunkId] + ".chunk.js";
};